/**
 * @fileOverview Exactly the same as the <FixedGlobalSearch /> component but
 * handles the url integration
 */

import React, { useState } from 'react'
import FixedGlobalSearch from './FixedGlobalSearch'
import { makeArray } from './../../Utils/Array'
import querystring from 'querystring'

/**
 * Returns the tags that are in the query string
 * @param {string} search The query string
 */
export const getTagsFromSearchQuery = function(search) {
  if (search.startsWith('?')) search = search.slice(1)
  const query = querystring.parse(search)
  return makeArray(query.tags)
}

const FixedGlobalSearchWithUrl = props => {
  const { suggestions, location, onLocationChange } = props

  const [searchInput, setSearchInput] = useState('')

  const tags = getTagsFromSearchQuery(location.search)

  const addSearchTag = tag => {
    var newLocation = Object.assign({}, location)
    var query = querystring.parse(newLocation.search.slice(1))
    query['tags'] = makeArray(query['tags'] || [])
    query['tags'].push(tag)
    newLocation.search = '?' + querystring.stringify(query)
    onLocationChange(newLocation)
    setSearchInput('')
  }

  const removeSearchTag = tag => {
    var newLocation = Object.assign({}, location)
    var query = querystring.parse(newLocation.search.slice(1))
    query['tags'] = makeArray(query['tags'] || [])
    var index = query['tags'].indexOf(tag)
    if (index !== -1) query['tags'].splice(index, 1)
    newLocation.search = '?' + querystring.stringify(query)
    onLocationChange(newLocation)
  }

  return (
    <FixedGlobalSearch
      suggestions={suggestions}
      tags={tags}
      onSelectTag={addSearchTag}
      onRemoveTag={removeSearchTag}
      onInput={setSearchInput}
      value={searchInput}
    />
  )
}

export default FixedGlobalSearchWithUrl



// WEBPACK FOOTER //
// ./src/Components/FixedGlobalSearch/FixedGlobalSearchWithUrl.js